import { render, staticRenderFns } from "./FaqView.vue?vue&type=template&id=1793d950&scoped=true&"
import script from "./FaqView.vue?vue&type=script&lang=js&"
export * from "./FaqView.vue?vue&type=script&lang=js&"
import style0 from "./FaqView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FaqView.vue?vue&type=style&index=1&id=1793d950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1793d950",
  null
  
)

export default component.exports